import React, { useState } from 'react';
import CadastroDeCDRAdd from './add';

export default function CadastroDeCDR() {
  const [option] = useState('add');
  return <main>{option === 'add' && <CadastroDeCDRAdd />}</main>;
}
